import styled from 'styled-components'

// Chevron drawn in the accent colour (# must be escaped as %23 in a data URI)
const CHEVRON = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 8' fill='none' stroke='%23529fce' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M1 1.5 6 6.5 11 1.5'/></svg>"

export const Select = styled.select`
  appearance: none;
  -webkit-appearance: none;
  background-color: white;
  background-image: url("${CHEVRON}");
  background-repeat: no-repeat;
  background-position: right 1em center;
  background-size: 12px 8px;
  border: 2px solid transparent;
  border-radius: 8px;
  color: #0d1941;
  height: 3em;
  min-width: 8em;
  max-width: 100%;
  padding: 0 3em 0 1.2em;
  font-size: 1em;
  font-weight: bold;
  font-family: inherit;
  cursor: pointer;

  &:hover {
    border-color: #529fce;
  }

  &:focus {
    outline: none;
    border-color: rgb(0 79 255);
    box-shadow: 0 0 0 3px rgb(0 79 255 / 25%);
  }

  &:disabled {
    border-color: transparent;
    color: rgb(169 169 169);
    cursor: default;
  }
`
